<div class="downloadable-file">
    <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
            <p *ngIf="document.user" class="small mb-0">{{document.name}}</p> <p class="uploaded-for min color-base-50 mb-0">{{'FUNNEL.dealPage.documentStrings.uploadFor' | translate}} {{document.user}}</p>
        </div>
        <div class="actions d-flex align-items-center">
            <i *ngIf="document.crud" class="material-icons notranslate" (click)="openDeleteDocumentPopup(document)">delete</i>
            <i *ngIf="document.crud" class="material-icons notranslate" (click)="openEditdocumentPopup()">create</i>
            <a (click)="downloadFile(document.document_file)">
                <i class="material-icons notranslate">get_app</i>
            </a>
        </div>
    </div>
</div>


<onwac-modal 
    [title]="'FUNNEL.dealPage.documentStrings.editTitle' | translate" 
    [show]="editDocPopup.isVisible"
    (callback)="editDocPopup.close()">
    <div slot="content">
        <div class="form-group">
            <onwac-input 
            [type]="'select'" 
            [label]="'FUNNEL.dealPage.documentStrings.editCategory' | translate"
            [input_name]="'documentCategory'"
            [submitted]="submitted"
            [parentForm]="documentForm"
            [select_items]="categories"
            [selected_index]="categoryIndex"
            (onChangeSelect)="getCategory($event)"></onwac-input>
        </div>
        <div class="form-group">
            <onwac-input 
            [type]="'text'" 
            [label]="'FUNNEL.dealPage.documentStrings.editName' | translate" 
            [input_name]="'documentName'+document.identifier"
            [submitted]="submitted" 
            [parentForm]="documentForm" 
            [required]="true" ></onwac-input>
        </div>
    </div>
    <div slot="footer" class="button-row full-width">
        <onwac-button (click)="editDocPopup.close()" [text]="'FUNNEL.dealPage.documentStrings.editNo' | translate" [type]="'text'" [extra_clases]="'block'" ></onwac-button>
        <onwac-button (click)="editDocument()" [text]="'FUNNEL.dealPage.documentStrings.editYes' | translate" [extra_clases]="'block'" ></onwac-button>
    </div>
</onwac-modal>